export class DeviceModel {

  deviceUid: number;
  deviceUuid: string;
  deviceModel: string;
  deviceType: string;
  deviceOs: string;
  deviceAppVersion: string;
  deviceAppTypeUid: number;
  deviceAppTypeName: string;
  deviceLastLogin: string;
  deviceUserName: string;
  deviceUserEmail: string;

  constructor() 
  {

  }
}